<h2>Settings</h2>

<p>Default Region:{{mySettings.defaultRegion.regionName}}</p>